/** События аналитики: покупки. */
import { z } from "zod";
import { PosInt, UInt } from "../common";
import { Product } from "../monetization";
import { OfferPlace, PurchaseStatus } from "./common";

export const paymentsEvents = [
  /** Показано предложение покупки: экран «Штаб пал» с таймером или окно VIP с кнопки-замка. */
  z.object({ name: z.literal("offer_view"), props: z.object({ place: OfferPlace }) }),
  /** Показано предложение реванша (MADR 0007): `stars` 0 — бесплатно для VIP. */
  z.object({
    name: z.literal("revive_offer"),
    props: z.object({ wave: PosInt, attempt: PosInt, stars: UInt }),
  }),
  /** Чем кончилась волна после реванша: окупился ли он. */
  z.object({
    name: z.literal("revive_result"),
    props: z.object({ wave: PosInt, attempt: PosInt, outcome: z.enum(["cleared", "lost"]) }),
  }),
  /** Стартовый пакет показан: один раз на игрока. */
  z.object({ name: z.literal("starter_offer"), props: z.object({ place: OfferPlace }) }),
  /** Нажата покупка. На сайте и у гостя `telegram: false`: вместо счёта открывается Telegram. */
  z.object({
    name: z.literal("purchase_click"),
    props: z.object({ product: Product, place: OfferPlace, telegram: z.boolean() }),
  }),
  /** Чем кончился счёт Telegram. */
  z.object({
    name: z.literal("purchase_result"),
    props: z.object({
      product: Product,
      place: OfferPlace,
      status: PurchaseStatus,
    }),
  }),
] as const;
